import { render, staticRenderFns } from "./groupFitnessDashboardDownloads.vue?vue&type=template&id=3963fd81&scoped=true"
import script from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963fd81",
  null
  
)

export default component.exports